module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-36-45.007Z.90c04e00.png";